import ZulkifleeImage from "assets/images/corporate-profile/bod/Zulkiflee.svg";
import FaddaImage from "assets/images/corporate-profile/bod/Fadda.svg";
import JJImage from "assets/images/corporate-profile/bod/JJ.svg";
import Alajaji from "assets/images/corporate-profile/bod/Alajaji.svg";
// shariah
import Younes from "assets/images/corporate-profile/shariah/Younes.svg";
import Habeebullah from "assets/images/corporate-profile/shariah/Habeebullah.svg";
import Abdulmajid from "assets/images/corporate-profile/shariah/Abdulmajid.svg";
import Ashurov from "assets/images/corporate-profile/shariah/Ashurov.svg";
import Ifwat from "assets/images/corporate-profile/shariah/Ifwat.svg";

import ShamsulAnuar from "assets/images/corporate-profile/exco/SAM.png";
import Vincent from "assets/images/corporate-profile/exco/VL.png";
import LynnLau from "assets/images/corporate-profile/exco/LYNN.png";
import Faleel from "assets/images/corporate-profile/exco/UZMAN.png";
import Azreen from "assets/images/corporate-profile/exco/AZREEN.png";
import Azhar from "assets/images/corporate-profile/exco/AZHAR.png";
import Alfi from "assets/images/corporate-profile/exco/ALFI.png";
import AnnaTan from "assets/images/corporate-profile/exco/ANNA.png";
import CheeKinFung from "assets/images/corporate-profile/exco/CHEE_KIN_FUNG.png";
import Hayati from "assets/images/corporate-profile/exco/YATI.png";
import LumKokHuat from "assets/images/corporate-profile/exco/LUM_KOK_HUAT.png";
import RogerImage from "assets/images/corporate-profile/bod/Roger.png";
import { ASSETS_BASE_URL } from "constants";

export const rogerProfile = {
  name: "John Roger Winfield",
  position: "Chairman",
  image: RogerImage,
  biography: `John Roger Winfield was appointed as the Independent Non-Executive
          Director of the Board of alrajhi bank Malaysia on 15 January 2021 and
          subsequently appointed as Chairman effective 17 March 2021. He is of
          British nationality.
          <br />
          <br />
          Roger's banking career has spanned a period of over forty eight years.
          After an initial induction period in London with Lloyds Banking Group,
          he was asked by Lloyds to take up a role in South Korea in 1984 and
          subsequently in Japan, Taiwan and Singapore. In 1992 he joined
          Deutsche Bank in Singapore and then from 1999 to 2004, he was
          appointed Chief Executive Officer for Deutsche Bank in Mauritius,
          which he established from scratch, including obtaining separate
          banking and trust company licences. After joining HSBC at start of
          2005, he moved to the UAE in 2006 and then from March  2015 until his
          retirement early in 2021, Roger was the Chief Executive Officer of
          HSBC Kuwait.
          <br />
          <br />
          In addition to his two Country CEO roles, Roger has worked in many
          areas of banking during his career, including senior positions in
          commercial banking, trade finance, project finance, financial
          institutions, wholesale market risk, and private banking, where he was
          the Regional Head for the Southern Gulf region for HSBC.
          <br />
          <br />
          Some of his accreditations include President, Association of Offshore
          Banks, Mauritius (2000 and 2001), Appointed by Minister of Finance,
          Republic of Mauritius to be a Non-Executive Director, Financial
          Services Promotion Agency, Mauritius (December 2001 to December 2004),
          Elected as Charter Member of TiE Dubai (The Indus Entrepreneurs) in
          June 2008. Appointed as HSBC’s representative to the British Business
          Group, Northern Emirates, UAE in March 2014. Deputy Chairman and
          Treasurer, Board of Governors, The English School, Kuwait from March
          2015 until January 2021.`,
};
export const directorList = [
  {
    name: "Zulkiflee Hashim",
    position: "Independent Non-Executive Director",
    image: ZulkifleeImage,
    biography: `Zulkiflee Hashim was appointed as an Independent Non-Executive Director of alrajhi bank Malaysia on 15 January 2021.
<br/><br/>
Zulkiflee has over 35 years’ experience in the banking industry. He started his career with Citibank Malaysia in 1979 and left his position as Vice President in November 1991. From December 1991 to November 1997, Zulkiflee was with Deutsche Bank Malaysia. He was the Deputy Managing Director responsible for Corporate Banking, International Trade Finance, Operations and Transaction Banking Services. From July 1998 to October 2011, Zulkiflee was the Executive Director of Hong Leong Bank Berhad (‘HLB”). Prior to his retirement in 2015, he was HLB’s Chief Operating Officer, Group Strategic Support from November 2011 to January 2015. During the tenure with HLB, he was given the responsibility to oversee various areas such as Branch and Banking Operations, Integrated Risk Management, Credit Management, Information Technology, Islamic Banking, Wholesale Operations, Retail Operations, Legal and Corporate Communications & Public Relations.
<br/><br/>
Zulkiflee is presently an Independent Non-Executive Director of Small Medium Enterprise Development Bank Malaysia Berhad (SME Bank), Hong Leong MSIG Takaful Berhad and GuocoLand (Malaysia) Berhad. He was previously a member of Hong Leong Bank Berhad Board of Directors.`,
  },
  {
    name: "Abdulrahman A. Al Fadda",
    position: "Non-Independent Executive Director",
    image: FaddaImage,
    biography: `Abdulrahman is presently the Chief Financial Officer of alrajhi bank, Riyadh and was recently appointed Non-Independent Executive Director of alrajhi bank Malaysia on 15 January 2021.
<br/><br/>
He joined the Bank in September 2015 as General Manager of Group Treasury and a member of the High Management Committee. In September 2017, he was appointed and continues to be a member of the Board Investment Committee of Al Rajhi Company for Cooperative Insurance.
<br/><br/>
Abdulrahman holds a Bachelor of Science in Electrical Engineering from King Fahd University of Petroleum and Mineral, Dhahran. He started his career in Samba Financial Group, Riyadh in 1997 where he spent 14 years in various desks within its Treasury Division, which later saw his posting to its office in the UK. He played a key role in the subsequent centralisation of Samba’s London Treasury activities in Riyadh.  In Sept 2011, he left his position as Head of Trading to join National Commercial Bank, Riyadh as Deputy Treasurer. In June 2012, he joined Saudi Investment Bank, Riyadh where he spent 3 years as Treasurer.
<br/><br/>
Abdulrahman is also the Chairman of Al Rajhi Financial Markets Board and sits on various other Boards namely Emkan Finance Company, Al Rajhi Development Company and Al Rajhi Company for Management Services.`,
  },
  {
    name: "Lim Jit Jee",
    position: "Independent Non-Executive Director​",
    image: JJImage,
    biography: `Lim Jit Jee (JJ) was appointed as the Independent Non-Executive Director of alrajhi bank Malaysia effective 6 October 2021. 
<br/><br/>
JJ’s vast experience lies in various disciplines across capital markets and financial services, with an illustrious career spanning a period of more than four decades. Throughout the years, he has held many roles ranging from securities operations, business development, critical project management, as well as advisory and consultancy.
<br/><br/>
As the Technology Advisor for Waafi Bank Ltd (Labuan), and previously the Chief Technology Officer of Affin Hwang Investment Bank, and the Consultant/Member of two of Bursa Malaysia's Board Task Force, he successfully spearheaded numerous technology-based initiatives in moving these organizations to the next level. 
<br/><br/>
JJ had joined Bursa Malaysia as the Head of Exchanges Operations of Market Operations before he was appointed as the Chief Information Officer to lead Bursa Malaysia’s technology and systems in 2008. Prior to Bursa Malaysia, JJ was the Executive Director of the Association of Stockbroking Companies of Malaysia.
<br/><br/>
JJ graduated with a Bachelor of Science in Computer Science from Sonoma State University, California, USA. The information technology professional has also served on the Board of several renowned organizations in Malaysia including JP Morgan Securities Sdn Bhd and Assunta Hospital.`,
  },
  {
    name: "Abdulrahman Alajaji",
    position: "Non-Independent Executive Director",
    image: Alajaji,
    biography: `Abdulrahman Alajaji is currently serving as the General Manager, Treasury Group at alrajhi bank, Riyadh and recently appointed as the Non-Independent Executive Director of alrajhi bank Malaysia effective 21 November 2023.
<br/><br/>
Mr Alajaji joined the bank in 2020 and is currently serving as the General Manager, Treasury Group at alrajhi bank KSA which includes International Banking Business (IBB) that was recently established to support the international businesses of al rajhi banking group. He brings a wealth of experience and a passion for driving global markets businesses and we are confident that his insights and experience will greatly contribute to our journey ahead.
<br/><br/>
He started his career in Banque Saudi Fransi, Riyadh in 1999 as International Brokerage and in 2006, he was a Senior-Foreign Exchange Trader where he starts his journey under the Saudi British Bank. He spent 14 years in various desks in global markets.
<br/><br/>
He holds a Bachelor of Computer Science from Hofstra University, New York.`,
  },
];

export const YounesProfile = {
  name: "Sheikh Prof. Younes Soualhi",
  image: Younes,
  position: "Chairman",
  biography: `Sheikh Prof. Younes Soualhi was appointed as the Deputy Chairman of the Shariah Committee since 1 January 2022. Over the past year, he has exemplified his unwavering commitment to ARBM through his invaluable guidance. Prof. Younes's extensive experience has significantly contributed to fulfilling his Shariah advisory responsibilities within the ARBM Shariah Committee. Recently, he has been appointed as the new Chairman of the Shariah Committee of alrajhi bank Malaysia effective 6 July 2023.
<br/><br/>
Currently, he is the Senior Researcher, the Deputy Director of Research and Innovation and the Head of Islamic Banking Unit at the International Shariah Research Academy for Islamic Finance (ISRA). Prof. Younes also teaches at INCEIF, the Global University of Islamic Finance, Malaysia.
<br/><br/>
A distinguished subject matter expert, Prof Younes was previously Chairman of the Shariah Committee of HSBC Amanah Malaysia Berhad, and currently Chairman of the Shariah Committee of Munich Re Retakaful, Chairman of the Shariah Council of Experts for Salam Takaful (Nigeria), Deputy Chairman of the Shariah Committee of ABC Bahrain Bank, Algeria, the sole Shariah Advisor for Kuwait Retakaful (Labuan, Malaysia), and Shariah Committee member of Bursa Malaysia. At the moment, he sits on the Shariah Sub-Committee (Malaysia region) of the Accounting and Auditing Organization for Islamic Financial Institutions (AAOIFI). He is also a registered financial planner (RFP, MFPC-Malaysia).
<br/><br/>
As a keen writer and researcher, Prof. Younes published many books and articles on Islamic Banking and Finance. With an extensive working experience of 26 years in academia, he taught various courses on Islamic Finance, Usul al-Fiqh, and Fiqh al Muamalat at both undergraduate and postgraduate (M.A. and Ph.D.) levels.  
<br/><br/>
He graduated with B.A. in Shariah from Emir Abdulqadir University for Islamic Sciences (Algeria). He received his M.A. from International Islamic University Malaysia and Ph.D. from University Malaya, Malaysia. He also holds a Diploma in Human Sciences.`,
};

export const HabeebullahProfile = {
  name: "Sheikh Dr. Habeebullah Zakariyah",
  image: Habeebullah,
  position: "Deputy Chairman of the Shariah Committee",
  biography: `
  Sheikh Dr. Habeebullah was appointed as the Member of the Shariah Committee of alrajhi bank Malaysia since 1 January 2022. Dr Habeebullah has contributed invaluable insights since becoming a member and continuous support in the organisation’s pursuit of excellence. Recently, he has been appointed as the Deputy Chairman of the Shariah Committee of alrajhi bank Malaysia Malaysia effective 6 July 2023.
<br/><br/>
He is currently the Senior Lecturer and Deputy Dean, Academic and Internationalization at the IIUM Institute of Islamic Banking and Finance, International Islamic University Malaysia (IIUM).
<br/><br/>
His areas of expertise and interests include Transactions in Islamic Banking and Finance, Islamic Social Finance, Islamic Capital Market, Takaful and Retakaful, Islamic Wealth Management, and Principles of Islamic Jurisprudence. Dr. Habeebullah has published and joint published numerous articles and book chapters on these subject matters in highly reputable academic journals.
<br/><br/>
He taught many courses in the field of Islamic Banking and Finance. Previously, he was the Head of Program for M.Sc. and Ph.D. in Islamic Banking and Finance at the IIUM Institute of Islamic Banking and Finance. He is also supervising postgraduate (M.A. and Ph.D.) students on Islamic Banking and Finance at the Institute.
<br/><br/>
He holds L.L.B in Shariah and Law from Omdurman Islamic University, Sudan, Master’s Degree and Ph.D. in Muamalat (Islamic Law of Transactions) from International Islamic University Malaysia. As an accomplished speaker, Dr. Habeebullah actively shares his knowledge and insights through regular participation in local and international conferences. 
  `,
};

export const shariahMemberList = [
  {
    name: "Sheikh Dr Abdulmajid Obaid Hasan Saleh",
    position: "Member",
    image: Abdulmajid,
    biography: `
      Sheikh Dr Abdulmajid Obaid Hasan Saleh was appointed as the Member of the Shariah Committee of alrajhi bank Malaysia, effective 6 July 2023.
<br/><br/>
Dr Abdulmajid is an Assistant Professor at the Institute of Islamic Banking and Finance, International Islamic University Malaysia. Being an expert in the field of Islamic finance, Dr Abdulmajid also garnered international recognition through his extensive publications, including books, articles, and plenary papers. Along with CSAA, he also holds a PhD in Fiqh & Islamic Finance from the Sidi Mohamed Ben Abdellah University, Morocco.
      `,
  },
  {
    name: "Sheikh Dr. Ashurov Sharofiddin",
    position: "Member",
    image: Ashurov,
    biography: `
      Dr. Ashurov Sharofiddin was appointed as Member of the Shariah Committee of alrajhi bank Malaysia, effective 1 April 2022. He is currently the Assistant Professor at the International Islamic University of Malaysia’s (IIUM) Institute of Islamic Banking and Finance, and the Chairman of the Committee of Islamic Financial Services (CIFS). Dr. Ashurov is also a Shariah Advisor at Alif Bank, and Head of Due Diligence and the Central Asia Representative for Searaven Global Corp Ltd.
<br/><br/>
Viewed as a highly inspiring individual in his areas of expertise, a polyglot and a keen writer, Dr. Ashurov has published numerous books and articles and presented various papers on zakat, risk-based supervisory, Sukuk and dynamic capital structure.
<br/><br/>
Along with a PhD in Islamic Banking and Finance from Universiti Islam Antarabangsa Sultan Abdul Halim Mu'adzam Shah (UniSHAMS), Dr. Ashurov also holds MSc in Finance from IIUM and a Bachelor of Economics from the International University of Africa, Sudan.
      `,
  },
  {
    name: "Sheikh Dr. Muhammad Shahrul Ifwat Bin Ishak",
    position: "Member",
    image: Ifwat,
    biography: `
      Dr. Muhammad Shahrul Ifwat Bin Ishak was appointed as Member of the Shariah Committee of alrajhi bank Malaysia, effective 8 February 2023.
<br/><br/>
Dr Shahrul is Senior Lecturer at the Faculty of Business and Management, University Sultan Zainal Abidin (UniSZA), Malaysia. He has been actively involved in Islamic finance, being the coordinator for the Masters in Islamic Finance program and has been teaching subjects related to Islamic banking and finance, such as the Principle of Islamic Jurisprudence, Islamic Financial Institutions and Markets, Shariah Aspects of Business and Finance, Financial Markets and Institutions, Usul Fiqh, Advanced Fiqh Muamalat and Shariah Rules in Financial Transactions.
<br/><br/>
Highly respected in his field of expertise, as well as highly proficient in both English and Arabic, Dr Shahrul is also an active publisher of books and articles on Maqasid Al-Shariah in Islamic finance, Ibra’, Ma’lat, and crowdfunding. Along with a PhD in Religious Studies from the University of Aberdeen, he also holds a Master of Fiqh and Usul Fiqh from the Ali-Albayt University of Jordan.
      `,
  },
];

export const executiveMemberList1 = [
  {
    name: "Shamsul Anuar<br>Bin Abdul Rashid",
    position: "Chief Financial Officer",
    image: `${ASSETS_BASE_URL}assets/images/exco/Shamsul.png`,
  },
  {
    name: "Vincent Lim Tien Kim",
    position: "Chief Corporate Banking Officer",
    image: Vincent,
  },
  {
    name: "Nur Lynn Lau Abdullah",
    position: "Chief Operating Officer",
    image: LynnLau,
  },
  {
    name: "Muhammed Uzman<br>Muhammed Faleel",
    position: "Chief Risk Officer",
    image: `${ASSETS_BASE_URL}assets/images/exco/Uzman.png`,
  },
];

export const executiveMemberList2 = [
  {
    name: "Mohamed Azreen<br>Mohamed Shafeek",
    position: "Chief Treasury Officer",
    image: `${ASSETS_BASE_URL}assets/images/exco/Azreen.png`,
  },
  {
    name: "Azhar Bin Awang Kechil",
    position: "Chief Retail Banking Officer",
    image: `${ASSETS_BASE_URL}assets/images/exco/Azhar.png`,
  },
  {
    name: "Geok Hui Anna Tan",
    position: "Chief Compliance & Integrity Officer",
    image: AnnaTan,
  },
  {
    name: "Chee Kin Fung",
    position: "Chief Internal Auditor",
    image: `${ASSETS_BASE_URL}assets/images/exco/Chee.png`,
  },
];

export const executiveMemberList3 = [
  {
    name: "Nur Hayati Yob Ramli",
    position: "Chief Human Resources Officer",
    image: Hayati,
  },
  {
    name: "Lum Kok Huat",
    position: "Chief Governance & Legal Officer",
    image: `${ASSETS_BASE_URL}assets/images/exco/Lum.png`,
  },
];
